// removed by extract-text-webpack-plugin
module.exports = {"container":"_2qYziRquk23Qq97g2kBhaX"};